
import {initWebComponent} from "@/helpers/web-component-helper";
import {showLayerInfoButton} from "@/helpers/layer/info/layer-info-helper";
import {stopDraw} from "@/helpers/ol/draw/ol-draw-polygon-helper";

export class LayerInfoInfoButtonComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        template.innerHTML = `<layer-info-button data-icon="fa fa-info" data-title="information"></layer-info-button>`;

        initWebComponent(this, template)

        this.addEventListener('click', () => {
            showLayerInfoButton('layer-info-info')

            if(window.table !== undefined) {
                window.table.columns.adjust()
            }

            stopDraw()
        })
    }
}

